/**
 * Client-only session bootstrap — NOT a route guard.
 *
 * Redirects belong in `middleware/auth.global.ts` (and the early bounce in
 * `app.html`). This plugin only pulls the Sanctum token from cookie /
 * localStorage into Nuxt state before the first client navigation so
 * `loadSession()` / middleware see it.
 */
export default defineNuxtPlugin({
  name: 'auth-token',
  enforce: 'pre',
  setup() {
    const { loadToken } = useApi()
    loadToken()
  },
})
